import React, { useState, useEffect } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import close from "../../../../../../../../assets/close.svg";
import CustomSelect from '../../../../../../../../Util/CustomSelect/CustomSelect';
import { messages } from '../../../../../../../../messages';
import moment from 'moment';
import { config } from "../../../../../../../../config";
import axiosApi from "../../../../../../../../core/interceptor/interceptor";
import _ from "lodash";
import "./AddMatchup.css";

export default function AddMatchup(props) {
  const [payload, setPayload] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [matchup, setMatchup] = useState(props.matchup);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setPayload({
      league_id: props.leagueId ? +props.leagueId : 0,
      week: props.week ? +props.week : 0,
      date: new Date(),
      time: null,
      location_id: null,
      field_id: null,
      team1_id: null,
      team2_id: null
    });
    //eslint-disable-next-line
  }, []);

  /*** closes modal *****/
  const closeModal = (resp = false) => {
    if (props.closeModal) {
      props.closeModal(resp);
    }
  }

  const onSelect = (data, type) => {
    if (data && data.title) {
      handleModalCloseResponse({ type, data: !['time'].includes(type) ? data.id : data.title });
    }
  }

  const handleModalCloseResponse = (resp, locationChange) => {
    if (resp && resp.data) {
      setPayload(prevData => ({
        ...prevData,
        [resp.type]: resp.data,
      }));

      if (locationChange) {
        const fields = [].concat.apply([], matchup.locationFields.map(x => x.fields)).filter(x => +x.parent_id === +resp.data);
        setMatchup(prev => {
          const filter_ = {
            ...prev,
            fields,
          };
          return filter_;
        })
      }
    }
  }

  const teamName = (id) => {
    let name = '--';
    if (id && matchup && matchup.teamData) {
      name = matchup.teamData.find(x => +x.id === +id) ? matchup.teamData.find(x => +x.id === +id).name : '--';
    }
    return name;
  }

  const locationName = (id) => {
    let name = '';
    if (id && matchup && matchup.locationFields) {
      name = matchup.locationFields.find(x => +x.id === +id) ? matchup.locationFields.find(x => +x.id === +id).title : '';
    }
    return name;
  }

  const fieldName = (id, parent_id) => {
    let name = '';
    if (id && matchup && matchup.fields) {
      if (parent_id) {
        name = matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)) ? matchup.fields.find(x => (+x.id === +id && +x.parent_id === +parent_id)).title : '';
      } else {
        name = matchup.fields.find(x => +x.id === +id) ? matchup.fields.find(x => +x.id === +id).title : '';
      }
    }
    return name;
  }

  const handleSubmit = (event) => {
    event.preventDefault();
    setFormSubmitted(true);
    if (_.values(payload).some(x => !x)) {
      return;
    }
    const data = {...payload};
    data.time = data.time ? moment(data.time, 'hh:mm A').format('HH:mm') : null;
    data.date = data.date ? moment(data.date).format('YYYY-MM-DD') : null;
    axiosApi.post(`${config.apiUrl}/leagues/active/weekly/matchup`, data).then((resp) => {
      if (props.refresh) {
        props.refresh();
      }
      closeModal();
    }).catch((err) => {
      console.error(err);
    });
  }

  const datePickerClick = () => {
    setIsOpen(!isOpen);
  }

  return <>
    <div className="modal addMatchup">
      <div className="modal-header">
        <h2>Add Matchup</h2>
        <p>Enter matchup info</p>
        <span className="close" onClick={closeModal}>
          <img src={close} alt='close-icon' />
        </span>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="modal-content addMatchup-Modal">
          <div className="input-field">
            <label>Date</label>
            <DatePicker
              open = {isOpen}
              placeholderText={'MM/DD/YYYY'}
              minDate={new Date()}
              selected={payload.date}
              autoFocus={false}
              onChange={(date) => {handleModalCloseResponse({ type: 'date', data: date }); datePickerClick();}}
              onClickOutside={datePickerClick}
              onInputClick= {datePickerClick}
            />
            {!payload.date && formSubmitted && <span className="error">{messages.start_date_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'time-level-key'}
              data={matchup?.times}
              label={'Time'}
              placeholder={payload.time ? payload.time : 'Select Time'}
              type={'time'}
              onSelect={onSelect}
              selector="title"
            />
            {!payload.time && formSubmitted && <span className="error">{messages.timeSlot_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'location-level-key'}
              data={matchup?.locationFields}
              label={'Location'}
              placeholder={payload.location_id ? locationName(payload.location_id) : 'Select Location'}
              type={'location_id'}
              onSelect={(location) => handleModalCloseResponse({ type: 'location_id', data: location?.id }, true)}
              selector="title"
            />
            {!payload.location_id && formSubmitted && <span className="error">{messages.location_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'field-level-key'}
              data={matchup?.fields}
              label={'Field'}
              placeholder={payload.field_id ? fieldName(payload.field_id, payload?.location_id) : 'Select Field'}
              type={'field_id'}
              onSelect={onSelect}
              selector="title"
            />
            {!payload.field_id && formSubmitted && <span className="error">{messages.field_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'team1-level-key'}
              data={matchup?.teamData}
              label={'Team 1'}
              placeholder={payload.team1_id ? teamName(payload.team1_id) : 'Select Team 1'}
              type={'team1_id'}
              onSelect={onSelect}
              selector="title"
            />
            {!payload.team1_id && formSubmitted && <span className="error">{messages.team1_error}</span>}
          </div>
          <div className="select-blk">
            <CustomSelect
              required={true}
              uniqueKey={'team2-level-key'}
              data={matchup?.teamData}
              label={'Team 2'}
              placeholder={payload.team2_id ? teamName(payload.team2_id) : 'Select Team 2'}
              type={'team2_id'}
              onSelect={onSelect}
              selector="title"
            />
            {!payload.team1_id && formSubmitted && <span className="error">{messages.team2_error}</span>}
          </div>
        </div>
        <div className="modal-footer d-flex">
          <button className="cancel-btn" onClick={closeModal}>Cancel</button>
          <button type="submit" >Confirm</button>
        </div>
      </form>
    </div>
  </>
}